(() => {
  const SECTION_SELECTOR = '[data-ckl-home-hats]';

  const initSection = (section) => {
    if (!section || !window.CKLHomeCarouselDots || window.CKLHomeCarouselDots.isDesktop()) return;

    const track = section.querySelector('[data-ckl-hats-track]');
    const dots = Array.from(section.querySelectorAll('.ckl-home-hats__dot'));
    const cards = Array.from(section.querySelectorAll('.ckl-home-hats__card'));
    if (!track || dots.length < 3 || cards.length < 6) return;

    window.CKLHomeCarouselDots.bindCarouselDots({
      root: section,
      track,
      dots,
      labelPrefix: 'Hat styles page',
      getTargets: () => {
        const base = cards[0].offsetLeft;
        return [0, 2, 4].map((cardIndex) => Math.max(0, cards[cardIndex].offsetLeft - base));
      }
    });
  };

  const initAll = (root = document) => {
    if (!window.CKLHomeCarouselDots) return;
    root.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      if (window.CKLHomeCarouselDots.isDesktop()) {
        if (section._cklDotsAbort) {
          section._cklDotsAbort.abort();
          section._cklDotsAbort = null;
        }
        return;
      }
      initSection(section);
    });
  };

  const start = () => initAll();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));

  if (window.matchMedia) {
    window.matchMedia('(min-width: 1000px)').addEventListener('change', () => initAll());
  }
})();
